<template>
  <aside class="widget" v-if="$route.name !== 'Recognition' && $route.name !== 'Recognition'">
    <h4>ThinkTank Links</h4>
    <router-link to="/recognition"><h5><i class="fas fa-quote-left fa-fw fa-sm"></i> MultiChoice Recognition <i class="fas fa-angle-right fa-xs"></i></h5></router-link>
    <!--router-link to="/employment-equity"><h5><i class="fas fa-thumbs-up fa-fw fa-sm"></i> Employment Equity <i class="fas fa-angle-right fa-xs"></i></h5></router-link>
    <router-link to="/innovation-always-on-site"><h5><i class="fa fa-lightbulb fa-fw fa-sm"></i> Innovation Always on Site <i class="fas fa-angle-right fa-xs"></i></h5></router-link-->
    <router-link v-if="viewEmployeeAwards" to="/employee-award"><h5><i class="fa fa-lightbulb fa-fw fa-sm"></i> Employee/Team of the Month <i class="fas fa-angle-right fa-xs"></i></h5></router-link>
    <router-link v-if="viewEmployeeAwardsRegional" to="/employee-award-regional"><h5><i class="fa fa-lightbulb fa-fw fa-sm"></i>Regional Employee of the Month<i class="fas fa-angle-right fa-xs"></i></h5></router-link>    
    <router-link v-if="viewEmployeeYearAwards" to="/bu-employee-award-year"><h5><i class="fa fa-lightbulb fa-fw fa-sm"></i>BU Employee of the Year <i class="fas fa-angle-right fa-xs"></i></h5></router-link>
    <router-link v-if="viewMCGEmployeeYearAwards" to="/mcg-employee-award-year"><h5><i class="fa fa-lightbulb fa-fw fa-sm"></i> MCG Employee of the Year <i class="fas fa-angle-right fa-xs"></i></h5></router-link>    
    <!--router-link to="/innovation-awards"><h5><i class="fa fa-lightbulb fa-fw fa-sm"></i> Innovation Awards <i class="fas fa-angle-right fa-xs"></i></h5></router-link-->
    <!--router-link to="/idea-challenges"><h5><i class="fas fa-shopping-cart fa-fw fa-sm"></i> Idea Challenges <i class="fas fa-angle-right fa-xs"></i></h5></router-link>
    <router-link to="/communities"><h5><i class="fas fa-user-friends fa-fw fa-sm"></i> Communities <i class="fas fa-angle-right fa-xs"></i></h5></router-link>
    <router-link to="/digital-store"><h5><i class="fas fa-shopping-cart fa-fw fa-sm"></i> Digital Store <i class="fas fa-angle-right fa-xs"></i></h5></router-link>
    <router-link to="/page/user-guide"><h5><i class="fas fa-question-circle fa-fw fa-sm"></i> Technical Guide <i class="fas fa-angle-right fa-xs"></i></h5></router-link-->

    <h4>Reports</h4>

    <router-link v-if="viewLineManagerReport" to="/Recognition-Report/Manager"><h5><i class="fas fa-file-alt fa-fw fa-sm"></i> Manager Recognition Report <i class="fas fa-angle-right fa-xs"></i></h5></router-link>
    <router-link v-if="viewExco2Report" to="/Recognition-Report/EXCO2"><h5><i class="fas fa-file-alt fa-fw fa-sm"></i> EXCO2 Recognition Report <i class="fas fa-angle-right fa-xs"></i></h5></router-link>
    <router-link v-if="viewHCBPReport" to="/Recognition-Report/HCBP"><h5><i class="fas fa-file-alt fa-fw fa-sm"></i> HCBP Recognition Report <i class="fas fa-angle-right fa-xs"></i></h5></router-link>
    <router-link v-if="viewReport" to="/Reward-Recognition-Report"><h5><i class="fas fa-file-alt fa-fw fa-sm"></i> My Reward Recognition Reports <i class="fas fa-angle-right fa-xs"></i></h5></router-link>
    <router-link v-if="viewEmployeeAwardsRegional" to="/HCBP-EOM-TOM-Report-Regional"><h5><i class="fas fa-file-alt fa-fw fa-sm"></i> Regional EOM Report <i class="fas fa-angle-right fa-xs"></i></h5></router-link>    
    <router-link v-if="viewEOMReport" to="/HCBP-EOM-TOM-Report"><h5><i class="fas fa-file-alt fa-fw fa-sm"></i> HCBP EOM/TOM Report <i class="fas fa-angle-right fa-xs"></i></h5></router-link>
    <router-link v-if="viewEmployeeYearAwards" to="/BU-EOY-Report"><h5><i class="fas fa-file-alt fa-fw fa-sm"></i> BU EOY Award Report <i class="fas fa-angle-right fa-xs"></i></h5></router-link>
    <router-link v-if="viewMCGEmployeeYearAwardsReport" to="/MCG-EOY-Report"><h5><i class="fas fa-file-alt fa-fw fa-sm"></i> MCG EOY Award Report <i class="fas fa-angle-right fa-xs"></i></h5></router-link>
    <router-link v-if="viewMCGEmployeeYearAwardsCountReport" to="/MCG-EOY-Report-count"><h5><i class="fas fa-file-alt fa-fw fa-sm"></i> MCG EOY Award Count Report <i class="fas fa-angle-right fa-xs"></i></h5></router-link>
  </aside>
  <aside class="widget" v-else>
    <h4>#we<span style="color:red;">see</span>you Links</h4>
    <router-link to="/recognition/how-it-works">
      <h5 class="row mr-0 ml-0">
        <div class="col-12 pl-0 mr-0"><i class="fa fa-file-alt"></i> How it works?</div>
      </h5>
    </router-link>
    <router-link to="/recognition/who-gives-and-who-gets">
      <h5 class="row mr-0 ml-0">
        <div class="col-12 pl-0 mr-0 mt-3"><i class="fa fa-gift"></i> Who gives and who gets?</div>
      </h5>
    </router-link>
    <router-link to="/recognition/how-to-write-a-motivation">
      <h5 class="row mr-0 ml-0">
        <div class="col-12 pl-0 mr-0 mt-3"><i class="fa fa-life-ring"></i> How to write a motivation</div>
      </h5>
    </router-link>
    <router-link to="/recognition/the-multichoice-way">
      <h5 class="row mr-0 ml-0">
        <div class="col-12 pl-0 mr-0 mt-3"><i class="fa fa-thumbs-up"></i> The MultiChoice Way</div>
      </h5>
    </router-link>
    <a v-on:click="toggleGuideChild">
      <h5 class="row mr-0 ml-0">
        <div class="col-12 pl-0 mr-0 mt-3"><i class="fa fa-question-circle"></i> Guide <i class="fas fa-angle-double-right fa-xs"></i></div>
      </h5>
    </a>
    <div class="ml-3" v-if="hideGuide === true">
      <a href="http://thinktankapi.multichoice.com/wp-content/uploads/2024/08/Employee_Guide.pdf" target="_blank">
        <h5 class="row mr-0 ml-0">
          <div class="col-12 pl-0 mr-0 mt-3"><i class="fa fa-clipboard-list"></i> Employee Guide</div>
        </h5>
      </a>
      <a  v-if="viewExco2Report || viewLineManagerReport" href="http://thinktankapi.multichoice.com/wp-content/uploads/2024/08/Line-Manager_Exco2-Guide.pdf" target="_blank">
        <h5 class="row mr-0 ml-0">
          <div class="col-12 pl-0 mr-0 mt-3"><i class="fa fa-clipboard-list"></i>Line Manager & Exco2 Guide</div>
        </h5>
      </a>      
      <a v-if="viewHCBPReport" href="http://thinktankapi.multichoice.com/wp-content/uploads/2024/08/HCBP-Guide.pdf" target="_blank">
        <h5 class="row mr-0 ml-0">
          <div class="col-12 pl-0 mr-0 mt-3"><i class="fa fa-clipboard-list"></i> HCBP Guide</div>
        </h5>
      </a>
    </div>
     <router-link to="/recognition/-terms-and-conditions">
      <h5 class="row mr-0 ml-0">
        <div class="col-12 pl-0 mr-0 mt-3"><i class="fa fa-clipboard-list"></i> Terms and conditions</div>
      </h5>
    </router-link>
  </aside>
</template>

<script>
import WordpressRestURI from '@/helpers/WordpressRestURI.js'
import { mapGetters } from 'vuex'
export default {
  data () {
    return {
      hideGuide: false
    }
  },
  computed: {
    // mix the getters into computed with object spread operator
    ...mapGetters([
      'viewEmployeeAwards',
      'viewReport',
      'viewLineManagerReport',
      'viewExco2Report',
      'viewHCBPReport',
      'viewEOMReport',
      'viewEmployeeYearAwards',
      'viewMCGEmployeeYearAwards',
      'viewMCGEmployeeYearAwardsReport',
      'viewMCGEmployeeYearAwardsCountReport',
      'viewEmployeeAwardsRegional'
    ])
  },
  methods: {
    getImage: function (path) {
      return WordpressRestURI.domainURI + path
    },
    toggleGuideChild: function () {
      this.hideGuide = !this.hideGuide
    }
  },
  watch: {
    '$route' (to, from) {
      this.hideGuide = false
    },
  }
}
</script>



// WEBPACK FOOTER //
// src/components/ThinkTankLinks.vue